// Sons des alertes (04/10/2026), identique dans la Clinique et la Caisse.
// - Sons courts et distincts, produits par le navigateur (aucun fichier audio à installer).
// - Un son seulement quand un compteur augmente (la première lecture sert de référence) ; un seul son à la fois.
// - Réglages propres au poste (localStorage) : sons activés, volume, alertes choisies.
// - Navigateur : l'audio se déverrouille au premier clic ou à la première touche ; l'application de bureau
//   (Electron) l'autorise d'emblée (autoplayPolicy dans background.js).

const CLE = 'clinicaa.sons-alertes'

// [fréquence Hz, début s, durée s]
export const SONS = {
    transferts: { libelle: 'Transfert à accueillir', notes: [[659, 0, 0.16], [880, 0.18, 0.32]] },
    soins: { libelle: 'Soins en retard ou à faire', notes: [[523, 0, 0.2], [523, 0.28, 0.2]] },
    demandes_sites: { libelle: 'Demande de rendez-vous du site', notes: [[784, 0, 0.12], [988, 0.14, 0.12], [1175, 0.28, 0.22]] },
    validations: { libelle: 'Demande à valider', notes: [[440, 0, 0.3]] },
}

// Un seul son par actualisation : le plus urgent.
export const PRIORITE = ['transferts', 'soins', 'validations', 'demandes_sites']

const DEFAUT = { actif: true, volume: 0.6, alertes: {} }

export function lireReglages() {
    try {
        const brut = window.localStorage.getItem(CLE)
        const lu = brut ? JSON.parse(brut) : {}
        return { actif: lu.actif !== false, volume: typeof lu.volume === 'number' ? Math.min(1, Math.max(0, lu.volume)) : DEFAUT.volume,
            alertes: lu.alertes && typeof lu.alertes === 'object' ? lu.alertes : {} }
    } catch (erreur) {
        return { actif: DEFAUT.actif, volume: DEFAUT.volume, alertes: {} }
    }
}

export function enregistrerReglages(reglages) {
    try { window.localStorage.setItem(CLE, JSON.stringify(reglages)) } catch (erreur) { /* stockage indisponible : réglage de la session seulement */ }
}

export function alerteActive(reglages, type) {
    return !!(reglages && reglages.actif && reglages.alertes[type] !== false)
}

let contexte = null
function audio() {
    if (typeof window === 'undefined') return null
    const Contexte = window.AudioContext || window.webkitAudioContext
    if (!Contexte) return null
    if (!contexte) {
        try { contexte = new Contexte() } catch (erreur) { return null }
    }
    return contexte
}

export function deverrouiller() {
    const c = audio()
    if (c && c.state === 'suspended' && c.resume) c.resume().catch(() => {})
    return c
}

// Premier clic ou première touche : le navigateur autorise ensuite les sons.
export function installerDeverrouillage() {
    if (typeof document === 'undefined' || window.__sonsDeverrouillage) return
    window.__sonsDeverrouillage = true
    const essai = () => {
        const c = deverrouiller()
        if (c && c.state === 'running') {
            document.removeEventListener('pointerdown', essai, true)
            document.removeEventListener('keydown', essai, true)
        }
    }
    document.addEventListener('pointerdown', essai, true)
    document.addEventListener('keydown', essai, true)
}

// Joue le son d'une alerte ; force = bouton « Tester », même si l'alerte est désactivée.
export function jouer(type, reglages, force) {
    const r = reglages || lireReglages()
    if (!force && !alerteActive(r, type)) return false
    const son = SONS[type]
    const c = deverrouiller()
    if (!son || !c || c.state === 'closed') return false
    const volume = Math.max(0.0002, (r.volume || 0) * 0.5)
    const depart = c.currentTime + 0.03
    son.notes.forEach(([frequence, debut, duree]) => {
        const oscillateur = c.createOscillator()
        const gain = c.createGain()
        oscillateur.type = 'sine'
        oscillateur.frequency.value = frequence
        gain.gain.setValueAtTime(0.0001, depart + debut)
        gain.gain.exponentialRampToValueAtTime(volume, depart + debut + 0.02)
        gain.gain.exponentialRampToValueAtTime(0.0001, depart + debut + duree)
        oscillateur.connect(gain)
        gain.connect(c.destination)
        oscillateur.start(depart + debut)
        oscillateur.stop(depart + debut + duree + 0.03)
    })
    return true
}

// Compteurs qui ont augmenté ; sans référence (première lecture), aucun.
export function nouveautes(precedent, actuel) {
    if (!precedent || !actuel) return []
    return Object.keys(actuel).filter(cle => (Number(actuel[cle]) || 0) > (Number(precedent[cle]) || 0))
}

export function sonAJouer(types) {
    return PRIORITE.find(type => types.indexOf(type) >= 0) || null
}
